module.exports = __webpack_public_path__ + "img/pr-5_.488f999f.png";